<template>
  <div>
    <Ibox :titulo="'Filtros'">
      <FormGroup
        cols="4"
        label="Programa">
        <v-select 
          v-if="filtro.id_programa != null"
          @input="onChangePrograma"
          :value="filtro.id_programa" 
          :clearable=false
          label="nombre_programa"
          :options="this.$store.getters['usuario/getProgramasFiltro']()" 
          :reduce="option=>option.id_programa">
        </v-select>
        <input class="form-control" disabled :value="'Sin programas para mostrar'" v-else>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Actividades"
        :is_loading="filtro.loading_actividades">
        <v-select 
          multiple
          v-model="filtro.id_actividad" 
          :selectable="(option) => !filtro.id_actividad.includes(option.id_actividad)"
          :clearable=false
          label="descripcion"
          :options="filtro.options_actividad" 
          :reduce="option=>option.id_actividad">
        </v-select>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Usuarios"
        :is_loading="filtro.loading_usuarios">
        <v-select 
          v-model="filtro.id_usuario"
          :clearable=false
          label="nombre_usuario"
          :options="filtro.options_usuario" 
          :reduce="usuario=>usuario.id_usuario">
        </v-select>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Fecha inicio (Visualización)"> 
        <Datepicker input-class="form-control" format="dd-MM-yyyy" v-model="filtro.fecha_i"></Datepicker>
      </FormGroup>
      <FormGroup
        cols="4"
        label="Fecha término (Visualización)"> 
        <Datepicker input-class="form-control" format="dd-MM-yyyy" v-model="filtro.fecha_t"></Datepicker>
      </FormGroup>
      <b-col cols="12">
        <b-button v-if="loading" variant="primary" style="float:right"><Loading :size="'1'" :text="'Cargando datos'"/></b-button>
        <b-button v-else-if="filtro.loading_usuarios || filtro.loading_actividades" variant="primary" style="float:right"><Loading :size="'1'" :text="'Cargando filtros'"/></b-button>
        <span v-else>
          <b-button variant="primary" style="float:right" v-on:click="cargarDatos()">Cargar</b-button>
        </span>
      </b-col>
    </Ibox>
    <Ibox :titulo="'Programación - Doble click para calendarizar'">
      <b-col cols="12">
        <b-skeleton v-if="loading"></b-skeleton>
        <span v-else-if="timeline.groups.length == 0">Sin datos para mostrar</span>
        <div v-else>
          <b-col cols="12" align="right" style="margin-bottom:10px; padding-right:0">
            <b-button v-if="utils.tienePermiso()" variant="danger" style="margin-right:5px" v-on:click="modalEliminarProgramacion()">Eliminar programación</b-button>
            <b-button v-if="utils.tienePermiso()" variant="success" style="margin-right:5px" v-on:click="modalCopiarProgramacion()">Copiar programación</b-button>
            <b-button variant="warning" style="margin-right:5px" v-on:click="ahora()">Ahora</b-button>
            <b-button variant="warning" style="margin-right:5px" v-on:click="centrar()">Centrar</b-button>
            <b-button variant="warning" style="margin-right:5px" v-on:click="move(0.2)">Izquierda</b-button>
            <b-button variant="warning" style="margin-right:5px" v-on:click="move(-0.2)">Derecha</b-button>
            <b-button variant="warning" style="margin-right:5px" v-on:click="zoom(-0.2)">Acercar</b-button>
            <b-button variant="warning" style="margin-right:5px" v-on:click="zoom(0.2)">Alejar</b-button>
          </b-col>
          <timeline 
            ref="timeline" 
            @click="click"
            @double-click="doubleclick"
            :items="timeline.items" 
            :groups="timeline.groups" 
            :options="timeline.options">
          </timeline>
        </div>
      </b-col>
    </Ibox>
     <b-modal :no-close-on-backdrop="true"  size="xl" hide-footer ref="modal_calendarizar" title="Agregar programación">
      <b-skeleton-table v-if="modal_calendarizar.loading" :columns="1"></b-skeleton-table>
      <b-row v-else>
        <FormGroup
          cols="6"
          label="Actividad">
          <input type="text" class="form-control" disabled v-model="modal_calendarizar.nombre_actividad">
        </FormGroup>
        <FormGroup
          cols="6"
          label="Tipo de programación">
          <v-select 
            v-model="modal_calendarizar.tipo_calendarizacion"
            :clearable=false
            :reduce="tipo=>tipo.v"
            :options="[
              {v:'rango',label:'Un formulario para el rango de fecha'},
              {v:'diario',label:'Un formulario por dia, entre los rangos de fecha'},
              {v:'mensual',label:'Un formulario por mes, entre los rangos de fecha'},
            ]">
          </v-select>
        </FormGroup>
        <FormGroup
          cols="6"
          v-if="modal_calendarizar.tipo_calendarizacion == 'mensual'"
          label="Mes inicio"> 
          <Datepicker minimum-view="month" input-class="form-control" format="MM-yyyy" v-model="modal_calendarizar.fecha_i"></Datepicker>
        </FormGroup>
        <FormGroup
          cols="6"
          v-else
          label="Fecha inicio"> 
          <Datepicker input-class="form-control" format="dd-MM-yyyy" v-model="modal_calendarizar.fecha_i"></Datepicker>
        </FormGroup>
        <FormGroup
          cols="6"
          v-if="modal_calendarizar.tipo_calendarizacion == 'mensual'"
          label="Mes fin"> 
          <Datepicker minimum-view="month" input-class="form-control" format="MM-yyyy" v-model="modal_calendarizar.fecha_t"></Datepicker>
        </FormGroup>
        <FormGroup
          cols="6"
          v-else
          label="Fecha fin"> 
          <Datepicker input-class="form-control" format="dd-MM-yyyy" v-model="modal_calendarizar.fecha_t"></Datepicker>
        </FormGroup>
        <FormGroup
          cols="6"
          label="Usuarios">
          <v-select 
            multiple
            v-model="modal_calendarizar.id_usuario"
            :clearable=false
            :selectable="(option) => !modal_calendarizar.id_usuario.includes(option.id_usuario)"
            label="nombre_usuario"
            :options="modal_calendarizar.options_usuario" 
            :reduce="usuario=>usuario.id_usuario">
          </v-select>
        </FormGroup>
        <FormGroup
          cols="6"
          label="Formulario">
          <v-select 
            placeholder="Seleccione uno o mas formularios para programar"
            multiple
            v-model="modal_calendarizar.id_formulario" 
            :selectable="(option) => !modal_calendarizar.id_formulario.includes(option.id_formulario)"
            :clearable=false
            label="nombre_formulario"
            :options="this.$store.getters['usuario/getFormulariosFiltro']()" 
            :reduce="option=>option.id_formulario">
          </v-select>
        </FormGroup>
        <b-col cols="12" v-if="modal_calendarizar.tipo_calendarizacion == 'mensual'">
          <label>Meses a calendarizar (Los meses en rojo no se calendarizaran)</label>
          <br>
          <br>
          <div style="margin-right:5px; float:left" v-for="mes in obtenerMesesEntreFechas(modal_calendarizar.fecha_i, modal_calendarizar.fecha_t)" :key="mes.orden">
            <b-button v-if="modal_calendarizar.meses.includes(mes)" v-on:click="calendarizarMes(mes)" variant="success">
              {{ meses[mes-1] }}
            </b-button>
            <b-button v-else v-on:click="calendarizarMes(mes)" variant="danger">
              {{ meses[mes-1] }}
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" v-if="modal_calendarizar.tipo_calendarizacion == 'diario'">
          <label>Dias de la semana a calendarizar (Los dias en rojo no se calendarizaran)</label>
          <br>
          <br>
          <b-button style="margin-right:5px" v-if="modal_calendarizar.dias_semana.includes(1)" v-on:click="calendarizarDiaSemana(1)" variant="success">Lunes</b-button>
          <b-button style="margin-right:5px" v-else v-on:click="calendarizarDiaSemana(1)" variant="danger">Lunes</b-button>
          <b-button style="margin-right:5px" v-if="modal_calendarizar.dias_semana.includes(2)" v-on:click="calendarizarDiaSemana(2)" variant="success">Martes</b-button>
          <b-button style="margin-right:5px" v-else v-on:click="calendarizarDiaSemana(2)" variant="danger">Martes</b-button>
          <b-button style="margin-right:5px" v-if="modal_calendarizar.dias_semana.includes(3)" v-on:click="calendarizarDiaSemana(3)" variant="success">Miércoles</b-button>
          <b-button style="margin-right:5px" v-else v-on:click="calendarizarDiaSemana(3)" variant="danger">Miércoles</b-button>
          <b-button style="margin-right:5px" v-if="modal_calendarizar.dias_semana.includes(4)" v-on:click="calendarizarDiaSemana(4)" variant="success">Jueves</b-button>
          <b-button style="margin-right:5px" v-else v-on:click="calendarizarDiaSemana(4)" variant="danger">Jueves</b-button>
          <b-button style="margin-right:5px" v-if="modal_calendarizar.dias_semana.includes(5)" v-on:click="calendarizarDiaSemana(5)" variant="success">Viernes</b-button>
          <b-button style="margin-right:5px" v-else v-on:click="calendarizarDiaSemana(5)" variant="danger">Viernes</b-button>
          <b-button style="margin-right:5px" v-if="modal_calendarizar.dias_semana.includes(6)" v-on:click="calendarizarDiaSemana(6)" variant="success">Sábado</b-button>
          <b-button style="margin-right:5px" v-else v-on:click="calendarizarDiaSemana(6)" variant="danger">Sábado</b-button>
          <b-button style="margin-right:5px" v-if="modal_calendarizar.dias_semana.includes(7)" v-on:click="calendarizarDiaSemana(7)" variant="success">Domingo</b-button>
          <b-button style="margin-right:5px" v-else v-on:click="calendarizarDiaSemana(7)" variant="danger">Domingo</b-button>
        </b-col>
        <b-col cols="12">
          <b-button v-if="modal_calendarizar.agregando" variant="primary" style="float:right"><Loading :size="'1'" :text="'Agregando programación'"/></b-button>
          <span v-else>
            <b-button variant="primary" style="float:right" v-on:click="agregarCalendarizacion()">Agregar</b-button>
          </span>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal :no-close-on-backdrop="true"  size="xl" hide-footer ref="modal_editar" title="Editar programación">
      <b-row>
        <FormGroup
          cols="6"
          label="Actividad">
          <input type="text" class="form-control" disabled v-model="modal_editar.nombre_actividad">
        </FormGroup>
        <FormGroup
          cols="6"
          label="Usuario">
          <input type="text" class="form-control" disabled v-model="modal_editar.nombre_usuario">
        </FormGroup>
        <FormGroup
          cols="6"
          label="Fecha inicio"> 
          <Datepicker input-class="form-control" format="dd-MM-yyyy" v-model="modal_editar.fecha_i"></Datepicker>
        </FormGroup>
        <FormGroup
          cols="6"
          label="Fecha fin"> 
          <Datepicker input-class="form-control" format="dd-MM-yyyy" v-model="modal_editar.fecha_t"></Datepicker>
        </FormGroup>
        <FormGroup
          cols="6"
          label="Formulario">
          <v-select 
            v-model="modal_editar.id_formulario" 
            :clearable=false
            label="nombre_formulario"
            :options="this.$store.getters['usuario/getFormulariosFiltro']()" 
            :reduce="option=>option.id_formulario">
          </v-select>
        </FormGroup>
        <b-col cols="12">
          <b-button v-if="modal_editar.editando" variant="primary" style="float:right"><Loading :size="'1'" :text="'Editando programación'"/></b-button>
          <b-button v-else-if="modal_editar.eliminando" variant="danger" style="float:right"><Loading :size="'1'" :text="'Eliminando programación'"/></b-button>
          <span v-else>
            <b-button variant="primary" style="float:right" v-on:click="editarCalendarizacion()">Editar</b-button>
            <b-button variant="danger" style="float:right; margin-right:10px" v-on:click="eliminarCalendarizacion()">Eliminar</b-button>
          </span>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal size="xl" hide-footer ref="modal_eliminar" title="Eliminar programación">
      <b-card class="mb-2" header="Seleccione un rango de fechas para eliminar la programación no realizada" header-bg-variant="success" header-text-variant="white">
        <b-card-text>
          <b-row style="margin-top:10px; margin-bottom:10px">
            <b-col cols="3">
              <FormGroup
                cols="12"
                label="Eliminar desde"> 
                <Datepicker 
                  @input="modalEliminarProgramacion"
                  input-class="form-control" 
                  format="dd-MM-yyyy" 
                  v-model="modal_eliminar.fecha_i">
                </Datepicker>
              </FormGroup>
              <FormGroup
                cols="12"
                label="Eliminar hasta"> 
                <Datepicker 
                  @input="modalEliminarProgramacion"
                  input-class="form-control" 
                  format="dd-MM-yyyy" 
                  v-model="modal_eliminar.fecha_t">
                </Datepicker>
              </FormGroup>
              <b-col cols="12">
                <b-skeleton-table :columns="1" :rows="3" v-if="modal_eliminar.loading"></b-skeleton-table>
                <b-list-group v-else>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Programa
                    <b-badge variant="primary">
                      {{ this.$store.getters['usuario/getProgramasFiltro']().find((element) => element.id_programa == filtro.id_programa).nombre_programa }}
                    </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Actividad
                    <b-badge variant="primary">
                    {{ this.filtro.options_actividad.length > 0 ? this.filtro.options_actividad.filter((element) => this.filtro.id_actividad.includes(element.id_actividad) ).map((element) => element.descripcion).join(', ') : null }}
                    </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Usuario
                    <b-badge variant="primary">
                    {{ filtro.options_usuario.length > 0 ? filtro.options_usuario.find((element) => element.id_usuario == filtro.id_usuario).nombre_usuario : null}}
                    </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total formularios
                    <b-badge variant="primary">
                    {{ modal_eliminar.rows.length }}
                    </b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-col>
            <b-col cols="9">
              <DataTable
                :loading="modal_eliminar.loading"
                :columns="modal_eliminar.columns"
                :rows="modal_eliminar.rows"
                :perPage="10"
                clases="table-bordered table-hover table-condensed nowrap">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'fecha_i'">
                    {{ utils.DateToFecha(utils.fechaToDate(props.row.fecha_i),'dd-mm-yyyy') }}
                  </span>
                  <span v-else-if="props.column.field == 'fecha_t'">
                    {{ utils.DateToFecha(utils.fechaToDate(props.row.fecha_t),'dd-mm-yyyy') }}
                  </span>
                </template>
              </DataTable>
            </b-col>
            <b-col cols="12">
              <b-button v-if="modal_eliminar.eliminando" variant="danger" style="float:right"><Loading :size="'1'" :text="'Eliminando programación'"/></b-button>
              <b-button v-else-if="modal_eliminar.loading" variant="danger" style="float:right"><Loading :size="'1'" :text="'Revisando programación'"/></b-button>
              <b-button v-else-if="modal_eliminar.status != 'success'" variant="danger" style="float:right">{{ modal_eliminar.msg }}</b-button>
              <span v-else>
                <b-button variant="primary" style="float:right" v-on:click="eliminarProgramacionMasivo()">Eliminar programación no realizada</b-button>
              </span>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
    </b-modal>
    <b-modal size="xl" hide-footer ref="modal_copiar" title="Copiar programación">
      <b-card class="mb-2" header="Seleccione un rango de fechas para copiar la programación" header-bg-variant="success" header-text-variant="white">
        <b-card-text>
          <b-row style="margin-top:10px; margin-bottom:10px">
            <b-col cols="3">
              <FormGroup
                cols="12"
                label="Copiar desde"> 
                <Datepicker 
                  @input="modalCopiarProgramacion"
                  input-class="form-control" 
                  format="dd-MM-yyyy" 
                  v-model="modal_copiar.fecha_i_c">
                </Datepicker>
              </FormGroup>
              <FormGroup
                cols="12"
                label="Copiar hasta"> 
                <Datepicker 
                  @input="modalCopiarProgramacion"
                  input-class="form-control" 
                  format="dd-MM-yyyy" 
                  v-model="modal_copiar.fecha_t_c">
                </Datepicker>
              </FormGroup>
              <b-col cols="12">
                <b-skeleton-table :columns="1" :rows="3" v-if="modal_copiar.loading"></b-skeleton-table>
                <b-list-group v-else>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Programa
                    <b-badge variant="primary">
                      {{ programaActual() != null ? programaActual().nombre_programa : null }}
                    </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Actividad
                    <b-badge variant="primary">
                    {{ this.filtro.options_actividad.length > 0 ? this.filtro.options_actividad.filter((element) => this.filtro.id_actividad.includes(element.id_actividad) ).map((element) => element.descripcion).join(', ') : null }}
                    </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Usuario
                    <b-badge variant="primary">
                    {{ filtro.options_usuario.length > 0 ? filtro.options_usuario.find((element) => element.id_usuario == filtro.id_usuario).nombre_usuario : null}}
                    </b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Total formularios
                    <b-badge variant="primary">
                    {{ modal_copiar.rows.length }}
                    </b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-col>
            <b-col cols="9">
              <DataTable
                :loading="modal_copiar.loading"
                :columns="modal_copiar.columns"
                :rows="modal_copiar.rows"
                :perPage="10"
                clases="table-bordered table-hover table-condensed nowrap">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'fecha_i'">
                    {{ utils.DateToFecha(utils.fechaToDate(props.row.fecha_i_c),'dd-mm-yyyy') }}
                  </span>
                  <span v-else-if="props.column.field == 'fecha_t'">
                    {{ utils.DateToFecha(utils.fechaToDate(props.row.fecha_t_c),'dd-mm-yyyy') }}
                  </span>
                </template>
              </DataTable>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
      <b-card class="mb-2" header="Seleccione un rango de fechas para pegar la programación" header-bg-variant="warning" header-text-variant="white">
        <b-card-text>
          <b-row style="margin-top:10px; margin-bottom:10px">
            <b-col cols="3">
              <FormGroup
                cols="12"
                label="Pegar desde"> 
                <Datepicker 
                  @input="modalCopiarProgramacion"
                  input-class="form-control" 
                  format="dd-MM-yyyy" 
                  v-model="modal_copiar.fecha_i_p">
                </Datepicker>
              </FormGroup>
              <FormGroup
                cols="12"
                label="Pegar hasta">
                <b-skeleton type="input" v-if="modal_copiar.loading"></b-skeleton>
                <input v-else class="form-control" disabled v-model="modal_copiar.fecha_t_p">
              </FormGroup>
            </b-col>
            <b-col cols="9">
              <DataTable
                :loading="modal_copiar.loading"
                :columns="modal_copiar.columns"
                :rows="modal_copiar.rows"
                :perPage="10"
                clases="table-bordered table-hover table-condensed nowrap">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'fecha_i'">
                    {{ utils.DateToFecha(utils.fechaToDate(props.row.fecha_i_p),'dd-mm-yyyy') }}
                  </span>
                  <span v-else-if="props.column.field == 'fecha_t'">
                    {{ utils.DateToFecha(utils.fechaToDate(props.row.fecha_t_p),'dd-mm-yyyy') }}
                  </span>
                </template>
              </DataTable>
            </b-col>
            <b-col cols="12">
              <b-button v-if="modal_copiar.copiando" variant="danger" style="float:right"><Loading :size="'1'" :text="'Copiando programación'"/></b-button>
              <b-button v-else-if="modal_copiar.loading" variant="danger" style="float:right"><Loading :size="'1'" :text="'Revisando programación'"/></b-button>
              <b-button v-else-if="modal_copiar.status != 'success'" variant="danger" style="float:right">{{ modal_copiar.msg }}</b-button>
              <b-button v-else-if="modal_copiar.rows.length == 0" variant="danger" style="float:right">No hay formularios entre las fechas de copiado</b-button>
              <span v-else>
                <b-button variant="primary" style="float:right" v-on:click="copiarProgramacion()">Copiar programación</b-button>
              </span>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import { globales, programaService } from '@/services';
import { utils } from '@/helpers';

export default {
  data(){
    return {
      utils,
      globales,
      loading: false,
      filtro: {
        id_programa: this.$store.state.usuario.programas.length > 0 ? this.$store.state.usuario.programas[0].id_programa : null,
        id_actividad: [0],
        id_usuario: 0,
        fecha_i: new Date(new Date().getFullYear(), 0, 1),
        fecha_t: new Date(new Date().getFullYear(), 11, 31),
        options_actividad:[],
        options_usuario:[],
        loading_actividades:true,
        loading_usuarios:true
      },
      timeline: {
        items: [],
        groups: [],
        options: null
      },
      modal_calendarizar: {
        loading:true,
        agregando:false,
        id_actividad:null,
        id_usuario:null,
        fecha_i:null,
        fecha_t:null,
        id_formulario:[],
        tipo_calendarizacion:'rango',
        nombre_actividad:'',
        options_usuario:[],
        dias_semana:[1,2,3,4,5,6,7],
        meses:[1,2,3,4,5,6,7,8,9,10,11,12]
      },
      meses:['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
      modal_editar: {
        editando:false,
        eliminando:false,
        id_calendario:null,
        id_formulario:null,
        id_usuario:null,
        fecha_i:null,
        fecha_t:null
      },
      modal_copiar: {
        copiando:false,
        loading:false,
        fecha_i_c:new Date(new Date().getFullYear(),new Date().getMonth(), 1),
        fecha_t_c:new Date(new Date().getFullYear(),new Date().getMonth() + 1, 0),
        fecha_i_p:new Date(new Date().getFullYear(),new Date().getMonth() + 1, 1),
        fecha_t_p:new Date(new Date().getFullYear(),new Date().getMonth() + 2, 1),
        status:null,
        msg:null,
        rows:[],
        columns:[
          {label: 'Actividad', field: 'nombre_actividad'},
          {label: 'Formulario', field: 'nombre_formulario'},
          {label: 'Ejecutor', field: 'nombre_usuario'},
          {label: 'Fecha inicio', field: 'fecha_i'},
          {label: 'Fecha termino', field: 'fecha_t'},
        ]
      },
      modal_eliminar: {
        loading:true,
        eliminando:false,
        fecha_i: new Date(new Date().getFullYear(),new Date().getMonth(), 1),
        fecha_t: new Date(new Date().getFullYear(),new Date().getMonth() + 1, 0),
        status:null,
        msg:null,
        rows:[],
        columns:[
          {label: 'Actividad', field: 'nombre_actividad'},
          {label: 'Formulario', field: 'nombre_formulario'},
          {label: 'Ejecutor', field: 'nombre_usuario'},
          {label: 'Fecha inicio', field: 'fecha_i'},
          {label: 'Fecha termino', field: 'fecha_t'},
        ]
      },
    }
  },
  mounted () {
    this.cargarActividades();
    this.cargarUsuarios();
  },
  methods : {
    calendarizarDiaSemana(dia){
      let index = this.modal_calendarizar.dias_semana.indexOf(dia);
      if(index == -1){
        this.modal_calendarizar.dias_semana.push(dia);
      }else{
        this.modal_calendarizar.dias_semana.splice(index,1);
      }
    },
    calendarizarMes(mes){
      let index = this.modal_calendarizar.meses.indexOf(mes);
      if(index == -1){
        this.modal_calendarizar.meses.push(mes);
      }else{
        this.modal_calendarizar.meses.splice(index,1);
      }
    },
    programaActual(){
      return this.$store.getters['usuario/getProgramasFiltro']().find((element) => element.id_programa == this.filtro.id_programa);
    },
    click(event){
      //reviso que clickeo algo
      if(event.item != null && utils.tienePermiso()){
        let calendario = this.timeline.items.find((element)=>{
          return element.id == event.item;
        });
        
        this.modal_editar.id_formulario = calendario.id_formulario;
        this.modal_editar.id_calendario = calendario.id_calendario;
        this.modal_editar.id_usuario = calendario.id_usuario;
        this.modal_editar.fecha_i = calendario.start;
        this.modal_editar.fecha_t = calendario.end;
        this.modal_editar.nombre_actividad = calendario.nombre_actividad;
        this.modal_editar.nombre_usuario = calendario.nombre_usuario;

        this.$refs['modal_editar'].show();
      }
    },
    doubleclick(event){
      //reviso que no clickeo algo
      if(event.item == null && utils.tienePermiso()){
        //obtengo id_usuario y id_actividad
        let group = event.group.split("_");
        this.modal_calendarizar.id_usuario = [group[1]];
        this.modal_calendarizar.id_actividad = group[0];
        this.modal_calendarizar.id_formulario = [];

        if(this.modal_calendarizar.id_usuario != "0"){
          this.modal_calendarizar.fecha_i = event.time;
          this.modal_calendarizar.fecha_t = event.time;

          let actividad_aux = this.filtro.options_actividad.find((element)=>{
            return element.id_actividad == this.modal_calendarizar.id_actividad
          });
          
          this.modal_calendarizar.nombre_actividad =  actividad_aux.descripcion;

          this.modal_calendarizar.loading = false;
          this.modal_calendarizar.dias_semana = [1,2,3,4,5,6,7];

          this.$refs['modal_calendarizar'].show();
        }
      }
    },
    agregarCalendarizacion(){
      this.modal_calendarizar.agregando = true;

      if(this.modal_calendarizar.id_formulario.length == 0 || this.modal_calendarizar.id_usuario.length == 0 || this.modal_calendarizar.id_usuario == null || this.modal_calendarizar.id_formulario == null){
        utils.alerta({status:'warning', msg:'Faltan campos obligatorios'});
        this.modal_calendarizar.agregando = false;
        return;
      }

      programaService.postProgramaCalendarizacion({
        id_usuario: this.modal_calendarizar.id_usuario,
        id_actividad: this.modal_calendarizar.id_actividad,
        fecha_i: utils.DateToFecha(this.modal_calendarizar.fecha_i, 'yyyy-mm-dd'),
        fecha_t: utils.DateToFecha(this.modal_calendarizar.fecha_t, 'yyyy-mm-dd'),
        id_formulario: this.modal_calendarizar.id_formulario,
        tipo_calendarizacion: this.modal_calendarizar.tipo_calendarizacion,
        dias_semana:this.modal_calendarizar.dias_semana,
        meses: this.modal_calendarizar.meses
      }).then(respuesta => {
        this.modal_calendarizar.agregando = false;
        utils.alerta(respuesta);

        if(respuesta.status == "success"){
          //socket
          this.cargarDatos(true);
          this.$refs['modal_calendarizar'].hide();
        }
      });
    },
    editarCalendarizacion(){
      this.modal_editar.editando = true;

      if(this.modal_editar.id_formulario == null){
        utils.alerta({status:'warning', msg:'Faltan campos obigatorios'});
        this.modal_editar.editando = false;
        return;
      }

      programaService.putProgramaCalendarizacion({
        id_usuario: this.modal_editar.id_usuario,
        id_calendario: this.modal_editar.id_calendario,
        id_formulario: this.modal_editar.id_formulario,
        fecha_i: utils.DateToFecha(this.modal_editar.fecha_i, 'yyyy-mm-dd'),
        fecha_t: utils.DateToFecha(this.modal_editar.fecha_t, 'yyyy-mm-dd')
      }).then(respuesta => {
        this.modal_editar.editando = false;
        utils.alerta(respuesta);

        if(respuesta.status == "success"){
          //socket
          this.cargarDatos(true);
          this.$refs['modal_editar'].hide();
        }
      });
    },
    eliminarCalendarizacion(){
      this.$fire({
        showCancelButton: true,
        html:'¿Esta seguro que desea eliminar la programación?',
        confirmButtonText:
          'Si',
        cancelButtonText:
          'No',
      }).then((confirm) => {
        if(confirm.value != null){

          this.modal_editar.eliminando = true;

          programaService.deleteProgramaCalendarizacion({
            id_calendario: this.modal_editar.id_calendario
          }).then(respuesta => {
            this.modal_editar.eliminando = false;
            utils.alerta(respuesta);

            if(respuesta.status == "success"){
              //socket
              this.cargarDatos(true);
              this.$refs['modal_editar'].hide();
            }
          });
        }
      });
    },
    modalEliminarProgramacion(){
      this.modal_eliminar.loading = true;
      this.$refs['modal_eliminar'].show();

      programaService.getDeleteProgramaCalendarizacionMasivo({
        id_usuario: this.filtro.id_usuario,
        id_actividad: utils.replaceValueWithArray(this.filtro.id_actividad, 0, this.filtro.options_actividad.map((element) => element.id_actividad)),
        id_programa: this.filtro.id_programa,
        fecha_i: utils.DateToFecha(this.modal_eliminar.fecha_i, 'dd-mm-yyyy'),
        fecha_t: utils.DateToFecha(this.modal_eliminar.fecha_t, 'dd-mm-yyyy')
      }).then(data => {
        this.modal_eliminar.rows = data.data;
        this.modal_eliminar.status = data.status;
        this.modal_eliminar.msg = data.msg;

        this.modal_eliminar.loading = false;
      });
    },
    eliminarProgramacionMasivo(){
      this.$fire({
        showCancelButton: true,
        html:'Se van a eliminar ' + this.modal_eliminar.rows.length + ' formularios entre '  + utils.DateToFecha(this.modal_eliminar.fecha_i, 'dd-mm-yyyy') + ' y el ' + utils.DateToFecha(this.modal_eliminar.fecha_t, 'dd-mm-yyyy') + ', ¿Esta seguro que desea continuar?',
        confirmButtonText:
          'Si',
        cancelButtonText:
          'No',
      }).then((confirm) => {
        if(confirm.value != null){

          this.modal_eliminar.eliminando = true;

          programaService.deleteProgramaCalendarizacionMasivo({
            id_usuario: this.filtro.id_usuario,
            id_actividad: utils.replaceValueWithArray(this.filtro.id_actividad, 0, this.filtro.options_actividad.map((element) => element.id_actividad)),
            id_programa: this.filtro.id_programa,
            fecha_i: utils.DateToFecha(this.modal_eliminar.fecha_i, 'dd-mm-yyyy'),
            fecha_t: utils.DateToFecha(this.modal_eliminar.fecha_t, 'dd-mm-yyyy')
          }).then(respuesta => {
            this.modal_eliminar.eliminando = false;
            utils.alerta(respuesta);

            if(respuesta.status == "success"){
              //socket
              this.cargarDatos(true);
              this.$refs['modal_eliminar'].hide();
            }
          });
        }
      });
    },
    modalCopiarProgramacion(){
      this.modal_copiar.loading = true;
      this.$refs['modal_copiar'].show();

      programaService.getCopyProgramaCalendarizacion({
        id_usuario: this.filtro.id_usuario,
        id_actividad: utils.replaceValueWithArray(this.filtro.id_actividad, 0, this.filtro.options_actividad.map((element) => element.id_actividad)),
        id_programa: this.filtro.id_programa,
        fecha_i_c: utils.DateToFecha(this.modal_copiar.fecha_i_c, 'dd-mm-yyyy'),
        fecha_t_c: utils.DateToFecha(this.modal_copiar.fecha_t_c, 'dd-mm-yyyy'),
        fecha_i_p: utils.DateToFecha(this.modal_copiar.fecha_i_p, 'dd-mm-yyyy')
      }).then(data => {
        this.modal_copiar.rows = data.data;
        this.modal_copiar.fecha_t_p = data.fecha_t_p;
        this.modal_copiar.status = data.status;
        this.modal_copiar.msg = data.msg;

        this.modal_copiar.loading = false;
      });
    },
    copiarProgramacion(){
      this.$fire({
        showCancelButton: true,
        html:'Se van a crear ' + this.modal_copiar.rows.length + ' formularios entre '  + utils.DateToFecha(this.modal_copiar.fecha_i_p, 'dd-mm-yyyy') + ' y el ' + this.modal_copiar.fecha_t_p + ', ¿Esta seguro que desea continuar?',
        confirmButtonText:
          'Si',
        cancelButtonText:
          'No',
      }).then((confirm) => {
        if(confirm.value != null){

          this.modal_copiar.copiando = true;

          programaService.copyProgramaCalendarizacion({
            id_usuario: this.filtro.id_usuario,
            id_actividad: utils.replaceValueWithArray(this.filtro.id_actividad, 0, this.filtro.options_actividad.map((element) => element.id_actividad)),
            id_programa: this.filtro.id_programa,
            fecha_i_c: utils.DateToFecha(this.modal_copiar.fecha_i_c, 'dd-mm-yyyy'),
            fecha_t_c: utils.DateToFecha(this.modal_copiar.fecha_t_c, 'dd-mm-yyyy'),
            fecha_i_p: utils.DateToFecha(this.modal_copiar.fecha_i_p, 'dd-mm-yyyy')
          }).then(respuesta => {
            this.modal_copiar.copiando = false;
            utils.alerta(respuesta);

            if(respuesta.status == "success"){
              //socket
              this.cargarDatos(true);
              this.$refs['modal_copiar'].hide();
            }
          });
        }
      });
    },
    cargarActividades(){
      this.filtro.loading_actividades = true;

      programaService.getProgramaActividades({
        id_programa: this.filtro.id_programa
      }).then(data => {
        this.filtro.options_actividad = data.data;
        this.filtro.options_actividad.unshift({id_actividad:0,descripcion:'Todo'});
        this.filtro.loading_actividades = false;
      });
    },
    cargarUsuarios(){
      this.filtro.loading_usuarios = true;

      programaService.getProgramaUsuarios({
        id_programa: this.filtro.id_programa
      }).then(data => {
        this.filtro.options_usuario = data.data;
        this.modal_calendarizar.options_usuario = Array.from(data.data);

        this.filtro.options_usuario.unshift({id_usuario:0,nombre_usuario:'Todo'});
        this.filtro.loading_usuarios = false;
      });
    },
    cargarDatos(update = false){
      if(!update){
        this.loading = true;
      }
      
      programaService.getProgramaTimelineCalendarizacion({
        id_programa: this.filtro.id_programa,
        id_actividad: utils.replaceValueWithArray(this.filtro.id_actividad, 0, this.filtro.options_actividad.map((element) => element.id_actividad)),
        id_usuario: this.filtro.id_usuario,
        fecha_i: utils.DateToFecha(this.filtro.fecha_i, 'dd-mm-yyyy'),
        fecha_t: utils.DateToFecha(this.filtro.fecha_t, 'dd-mm-yyyy')
      }).then(data => {
        if(data.status == 'success'){
          if(!update){
            this.timeline.options = {
              start:this.filtro.fecha_i,
              end:this.filtro.fecha_t,        
              orientation: 'top',
              editable: false,
              zoomMin: 1000 * 60 * 60 * 24 * 10
            };
          }
          this.timeline.groups = data.categorias;
          this.timeline.items = data.formularios;
        }else{
          this.timeline.groups = [];
          this.timeline.items = [];
        }
        if(!update){
          this.loading = false;
        }
      });
    },
    move(percentage){
      var range = this.$refs.timeline.getWindow();
      var interval = range.end - range.start;

      let newRango = {
          start: range.start.valueOf() - interval * percentage,
          end:   range.end.valueOf()   - interval * percentage
      };
      
      this.$refs.timeline.setWindow(newRango.start, newRango.end);
    },
    zoom(percentage){
      var range = this.$refs.timeline.getWindow();
      var interval = range.end - range.start;

      let newRango = {
          start: range.start.valueOf() - interval * percentage,
          end:   range.end.valueOf()   + interval * percentage
      };
      
      this.$refs.timeline.setWindow(newRango.start, newRango.end);
    },
    ahora(){
      let date = new Date();
      this.$refs.timeline.moveTo(date);
    },
    centrar(){
      this.$refs.timeline.setWindow(this.timeline.options.start, this.timeline.options.end);
    },
    onChangePrograma(id_programa){
      this.filtro.id_programa = id_programa;
      this.cargarActividades();
      this.cargarUsuarios();
    },
    obtenerMesesEntreFechas(fechaInicio, fechaFin) {
      if (!(fechaInicio instanceof Date) || !(fechaFin instanceof Date)) {
        return [];
      }

      let mesInicio = fechaInicio.getMonth() + 1;  // getMonth() retorna valores de 0 (Enero) a 11 (Diciembre)
      let añoInicio = fechaInicio.getFullYear();

      let mesFin = fechaFin.getMonth() + 1;
      let añoFin = fechaFin.getFullYear();

      let meses = [];

      while (añoInicio < añoFin || (añoInicio === añoFin && mesInicio <= mesFin)) {
        //solo agregar meses faltantes
        if(meses.includes(mesInicio) == false){
          meses.push(mesInicio);
        }

        // Incrementar mes y ajustar año si es necesario
        mesInicio++;
        if (mesInicio > 12) {
          mesInicio = 1;
          añoInicio++;
        }
      }
      return meses;
    }
  }
}
</script>

<style>
  .vdp-datepicker >>> input {
    padding: 0.75em 0.5em !important;
    font-size: 100% !important;
    border: 1px solid #ccc !important;
    width: 100% !important; 
  }

  .vis-item {
    cursor:pointer
  }

  .modal-xl {
    width: 90% !important;
    max-width: inherit;
  }
</style>
